<ng-container *ngIf="value !== undefined && format !== undefined">
	<span>{{ value }}</span><span [class.copo-numeric-cell-hidden]="format !== 'weight-with-zero' || !value">{{ value | copoHiddenNumber:format }}</span>
</ng-container>
